var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-headful',{attrs:{"title":'Callback ...',"description":"title"}})}
var staticRenderFns = []

export { render, staticRenderFns }